import { AiFillSafetyCertificate, AiOutlineQuestionCircle } from 'react-icons/ai'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import { InputCard } from './inputCard'
import { inovePagarme } from '../../../../services/pagarmeApi'
import { DotTypingLoader } from '../../../loaders/dotTypingLoader'

import cvvImg from '../../../images/cvv.png'
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';

import { Container, Button, ContentInput, TypeCard } from './style';


export function CardForm() {
    const [cardNumber, setCardNumber] = useState('')
    const [cardExpirationDate, setCardExpirationDate] = useState('')
    const [cardHolderName, setCardHolderName] = useState('')
    const [cardCvv, setCardCvv] = useState('')
    const [cardType, setCardType] = useState('credit_card')
    const [emptyInput, setEmptyInput] = useState(false)
    
    const [cardFocused, setCardFocused] = useState('')
  
    const [loadingCardInformations, setLoadingCardInformations] = useState(false)

    const sanitizingCardNumbers = (str) => str.replace(/[^0-9]/g, '')

    const history = useHistory()

  
    async function createPagarmeCard(customer_id) {
      const expDateSanitized = sanitizingCardNumbers(cardExpirationDate)
      const token = localStorage.getItem('@Inoveclube:token')

      const object = {
        customer_id,
        cardType,
        token,
        card: {
          number: sanitizingCardNumbers(cardNumber),
          holder_name: cardHolderName,
          exp_month: Number(expDateSanitized.slice(0, 2)),
          exp_year: Number(expDateSanitized.slice(2)),
          cvv: cardCvv,
          options: {
            verify_card: true
          }
        }
      }

      //console.log(object)

        await inovePagarme.post('/createCard', object, {
          headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('@Inoveclube:token')
          }
        }).then((response) => {
          const {idCard,brand} = response.data

          let data = {
            idPayment: 1000,
            icon: brand.toLowerCase(),
            description: `${brand} ••••${(object.card.number).slice(-4)}`,
            idCard: idCard,
            type: 'online'
         }
         

          localStorage.setItem('@Inoveclube:onlinepmtd',JSON.stringify(data));
          setLoadingCardInformations(false)
          
          history.goBack()
          toast.success('Cartão cadastrado com sucesso')
        })
        .catch((error) => {
          //console.log(error)
          setLoadingCardInformations(false)

          if(error.response.status === 404)
            toast.error('Cheque os dados do cartão')
          else
            toast.error('Algo deu errado, verifique se o cartão já está cadastrado')
        })
      

    }
  
  
    async function gettingIdPersonPagarme() {
      setLoadingCardInformations(true)
      try{
        await inovePagarme.get(`/getIdPersonPagarme/${localStorage.getItem('@Inoveclube:token')}`)
        .then(response => createPagarmeCard(response.data))
      }catch(error){
        if(error.response) {
          setLoadingCardInformations(false)
          toast.error(error.response.data.message)
          return
        }
        
        toast.error(error)
      }
    }  
  
    function handleClick() {
      if(cardNumber === '' || cardExpirationDate === '' || cardHolderName === '' || cardCvv === ''){
            setEmptyInput(true)
            toast.error('Preencha todas as informações')
        return
      }
  
      gettingIdPersonPagarme()
    }
    

    useEffect(() => {
      if(emptyInput === true)
        setTimeout(() => {
          setEmptyInput(false)
        }, 4000)
    }, [emptyInput])
   
    
    return(
        <Container>
            <Cards 
              cvc={cardCvv}
              expiry={cardExpirationDate}
              name={cardHolderName}
              number={cardNumber}
              focused={cardFocused}
              //className="teste"
              acceptedCards={['visa', 'mastercard', 'elo', 'amex', 'discover', 'jcb', 'hipercard']}
            />

       

            <div className="safe">
              <AiFillSafetyCertificate />
              <p>Compra Segura</p>
            </div>

            <h3>Detalhes do cartão</h3>

            <ContentInput>
                <p>Número do cartão</p>

                <InputCard 
                    placeholder="0000 0000 0000 0000"
                    value={cardNumber}
                    onChange={setCardNumber}
                    mask='9999 9999 9999 9999'
                    empty={emptyInput && cardNumber === ''}
                    cardType='number'
                    setCardFocused={setCardFocused}
                />
            </ContentInput>
           
           <div className='validityAndType'>
              <ContentInput>
                  <p>Validade</p>

                  <InputCard 
                      placeholder="MM/AA"
                      value={cardExpirationDate}
                      onChange={setCardExpirationDate}
                      mask='99/99'
                      empty={emptyInput && cardExpirationDate === ''}
                      cardType='expiry'
                      setCardFocused={setCardFocused}
                  />
              </ContentInput>

              <TypeCard>
                <select 
                  onChange={event => setCardType(event.target.value)} 
                  value={cardType}
                >
                  <option value="credit_card">Crédito</option>
                </select>
              </TypeCard>
           </div>
          
            <ContentInput>
                <p>Nome no cartão</p>

                <InputCard 
                    value={cardHolderName}
                    onChange={setCardHolderName}
                    empty={emptyInput && cardHolderName === ''}
                    cardType='name'
                    setCardFocused={setCardFocused}
                />
            </ContentInput>
           
            <ContentInput>
                <p 
                    className="cvvExplanation"
                >
                    CVV <AiOutlineQuestionCircle />
                </p>

                <InputCard 
                    value={cardCvv}
                    onChange={setCardCvv}
                    img={cvvImg}
                    maxLength={4}
                    empty={emptyInput && cardCvv === ''}
                    cardType='cvc'
                    setCardFocused={setCardFocused}
                />
            </ContentInput>


            <Button 
              onClick={handleClick}
              enable={loadingCardInformations}
            >
              {loadingCardInformations ?
                <DotTypingLoader />
                :
                'Cadastrar'
              }
            </Button>
            
        </Container>
    )
}
